export const environment = {
    production: false,
    hmr: true,

    baseUrl:'https://api.ikooworld.com',

    defaultLanguage: 'Label',
    supportedLanguages: ['Label', 'TMSA'],
};
